"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftSkeleton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_content_loader_1 = __importDefault(require("react-content-loader"));
const nft_skeleton_module_css_1 = __importDefault(require("./nft-skeleton.module.css"));
const NftSkeleton = ({ isTg }) => ((0, jsx_runtime_1.jsx)("div", { className: nft_skeleton_module_css_1.default.skeletonInner, children: (0, jsx_runtime_1.jsx)(react_content_loader_1.default, { speed: 2, width: "100%", height: "100%", viewBox: "0 0 227.5 231.5", backgroundColor: 'rgb(var(--placeholder-secondary))', foregroundColor: 'rgb(var(--secondary-bg))', children: (0, jsx_runtime_1.jsx)("rect", { x: "0", y: "0", rx: "30", ry: "30", width: "228", height: "232" }) }) }));
exports.NftSkeleton = NftSkeleton;
